import { useState } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useReviewReminder, useSetReviewReminder } from '@/lib/queries';
import { Button } from './ui/button';

export function ReviewReminderBanner() {
  const { t } = useTranslation();
  const query = useReviewReminder();
  if (!query.data?.due) return null;
  return (
    <aside
      aria-label={t('review.reminderTitle')}
      className="mb-5 flex flex-wrap items-center justify-between gap-2 rounded-card border border-line bg-accent-soft p-3"
    >
      <p className="text-sm">{t('review.reminderText')}</p>
      <Link
        to={`/review?week=${query.data.weekStart}`}
        className="inline-flex min-h-11 items-center px-2 text-sm font-medium text-accent"
      >
        {t('review.open')}
      </Link>
    </aside>
  );
}
export function ReviewReminderSettings() {
  const { t, i18n } = useTranslation();
  const query = useReviewReminder();
  const mutation = useSetReviewReminder();
  const [error, setError] = useState(false);
  return (
    <div className="rounded-card border border-line bg-surface p-4">
      <label className="flex flex-col gap-2 text-sm">
        {t('review.reminderTitle')}
        <select
          aria-label={t('review.reminderTitle')}
          className="h-11 min-w-0 rounded-lg border border-line bg-bg px-3 text-base"
          value={query.data?.day ?? ''}
          disabled={query.isPending || mutation.isPending || query.isError}
          onChange={async (e) => {
            setError(false);
            try {
              await mutation.mutateAsync(e.target.value === '' ? null : Number(e.target.value));
            } catch {
              setError(true);
            }
          }}
        >
          <option value="">{t('review.reminderOff')}</option>
          {[1, 2, 3, 4, 5, 6, 0].map((day) => (
            <option key={day} value={day}>
              {new Intl.DateTimeFormat(i18n.language, { weekday: 'long', timeZone: 'UTC' }).format(
                new Date(Date.UTC(2026, 8, 6 + day)),
              )}
            </option>
          ))}
        </select>
      </label>
      <p className="mt-2 text-xs text-muted">{t('review.reminderHint')}</p>
      {(error || query.isError) && (
        <div role="alert">
          <p>{t('week.saveFailed')}</p>
          <Button onClick={() => void query.refetch()}>{t('common.retry')}</Button>
        </div>
      )}
    </div>
  );
}
